import React from "react";

const MessageBubble = ({ message, onDeleteMessage, canDelete }) => {
  if (!message?.Users) return null;

  const isMine = message.user_id === message.currentUserId;

  const dt = new Date(message.createdAt);
  const dateStr = dt.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const timeStr = dt.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  // Couleurs bandeau : toi = violet, autres = ardoise
  const bubbleColor = isMine
    ? "bg-violet-600 dark:bg-violet-500"
    : "bg-slate-700 dark:bg-slate-600";

  return (
    <div className={`w-full flex ${isMine ? "justify-end" : "justify-start"}`}>
      {/* Conteneur aligné, largeur max 66% */}
      <div className={`inline-flex flex-col ${isMine ? "items-end" : "items-start"} max-w-[66%]`}>
        {/* Ligne 1 : Utilisateur | JJ/MM/AAAA | HH:MM + action supprimer (discrète) */}
        <div className="w-full flex items-center justify-between text-[11px] leading-tight text-slate-600 dark:text-slate-300 px-1">
          <span className="truncate">
            {message.Users.prenom} {message.Users.nom}
          </span>
          <div className="flex items-center gap-2 shrink-0">
            <span className="opacity-80">{dateStr} | {timeStr}</span>
            {canDelete && (
              <button
                onClick={onDeleteMessage}
                className="text-slate-400 hover:text-rose-500 transition"
                title="Supprimer"
                type="button"
              >
                Supprimer
              </button>
            )}
          </div>
        </div>

        {/* Séparateur fin (très compact) */}
        <div className="w-full h-px my-1 bg-slate-200 dark:bg-slate-800" />

        {/* Ligne 2 : bandeau message (compact, pas pleine largeur) */}
        <div
          className={`w-auto ${bubbleColor} text-white text-[13px] leading-snug rounded-md px-3 py-1.5 break-words`}
          style={{ wordBreak: "break-word" }}
        >
          {message.message}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
